import React, { useEffect } from "react";

import CardProject from "~/components/molecules/CardProject";
import { IProject } from "~/entities/project";
import { useIntersectionObserver } from "~/hooks/useIntersectionObserver";
import { cn } from "~/utilities/cn";

interface ISearchResultProps {
  title: string | React.ReactNode;
  className?: string;
  projects: IProject[];
  onLoadMore?: () => void;
  isLoading?: boolean;
}

const SearchResult: React.FC<ISearchResultProps> = ({
  title,
  className,
  projects,
  onLoadMore = () => {},
  isLoading = false,
}) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
  });

  useEffect(() => {
    if (isIntersecting) onLoadMore();
  }, [isIntersecting]);

  return (
    <div className={cn(className || "flex w-full flex-col  ")}>
      <div className={cn("flex items-center justify-between ")}>
        {typeof title === "string" ? (
          <h3 className="text-header-36 font-bold text-color">{title}</h3>
        ) : (
          title
        )}
      </div>
      <div className="grid grid-cols-3 gap-8 overflow-auto p-6 lg:grid-cols-2 lg:p-0 md:grid-cols-1">
        {projects?.map((project, index) => {
          const isLastItem = index === projects.length - 1;
          return (
            <div key={project.id} ref={isLastItem ? ref : null}>
              <CardProject
                className="col-span-1 h-full"
                bodyWrapperClass="flex-shrink flex-grow"
                key={project.id + index}
                project={project}
                hideDetails={false}
                showTenure={false}
                showAddress={true}
              />
            </div>
          );
        })}
      </div>
      {isLoading ? (
        <div className="mt-2 flex items-center justify-center gap-2">
          <span className="loading loading-dots loading-md"></span>
          <span className="loading loading-dots loading-md"></span>
          <span className="loading loading-dots loading-md"></span>
          <span className="loading loading-dots loading-md"></span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SearchResult;
